import {CtModelRouteData} from "@ctsolution/ct-framework";

export const LeadFileRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("leadfile");
